/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для остатков на складе в корзине.
   */
  app.CartRemainsView = app.View.extend({
    el: '.js-remains-comment_cart',
    events: {
      'click .js-close': 'hide',
      'click .js-opener-remains-popup': 'startOpen',
    },
    additionalOptions: ['bodyView', 'mainWindow'],

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#cart-remains-message-template');
      this.renderIfNotEnough();
      this.listenTo(this.cart, 'update', this.renderIfNotEnough);
      this.initPopup();
    },

    /**
     * Рендер шаблона, если есть товары в корзине, баланс которых больше остатка.
     */
    renderIfNotEnough: function () {
      if (this.cart && this.cart.cartInfo && this.cart.cartInfo.not_enough) {
        this.render();
      } else {
        this.$el.empty();
      }
    },

    /**
     * Инициализация попапа.
     */
    initPopup: function () {
      this.childViews.cartRemainsPopupView = new app.CartRemainsPopupView({
        el: '.js-item-remains-popup',
        collection: this.collection,
        cart: this.cart,
        mainWindow: this.mainWindow,
        bodyView: this.bodyView,
      });
    },

    /**
     * Обновление данных об изменившихся остатках.
     */
    fetchItems: function () {
      this.listenToOnce(this.collection, 'sync', this.openPopup);
      this.collection.reset();
      this.collection.getFirstPage();
    },

    /**
     * Запуск открытия попапа.
     */
    startOpen: function () {
      // не можем нарисовать сразу, потому что попап открывается через setTimeout
      this.listenToOnce(this.childViews.cartRemainsPopupView, 'popup:before-open', function () {
        this.childViews.cartRemainsPopupView.childViews.loader.render();
      });
      this.childViews.cartRemainsPopupView.toggle(true);
      this.childViews.cartRemainsPopupView.clearList();
      this.fetchItems();
    },

    /**
     * Открывает попап.
     */
    openPopup: function () {
      this.childViews.cartRemainsPopupView.render(true);
    },

    /**
     * Скрытие сообщения.
     */
    hide: function() {
      this.$el.addClass('not_display');
    },
  });
})(jQuery);

}.call(window));